import dayjs from "dayjs";

export const sendAPEvent = params => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(params);
};

export const getAge = birth => {
  return birth ? dayjs().diff(birth, "year") : null;
};

export const isLiveUser = userinfo => {
  return userinfo.liveTutorTicket > 0 || userinfo.pythonTicket > 0;
};

export const getDurationTime = startTime => {
  return dayjs.duration(dayjs().diff(startTime)).asMinutes().toFixed(2);
};
